// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/services/web/organization.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Struct } from "../../../../google/protobuf/struct";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { AttachmentDetails } from "../../types/attachments";
import { InvoicePreview, OrganizationCreditPlanState, UsageDataPoint, UsageSummary } from "../../types/billing";
import { CompanyDetails, CompanyUser, EnterpriseOrganization, OrganizationUser } from "../../types/company";
import { DocumentEntity, ProjectEntity } from "../../types/documents";

export const protobufPackage = "api.devplan.services.web.organization";

export enum OrganizationTrialStatus {
  ORGANIZATION_TRIAL_STATUS_UNSPECIFIED = 0,
  ORGANIZATION_TRIAL_STATUS_REQUIRED = 1,
  ORGANIZATION_TRIAL_STATUS_CHECKOUT_PENDING = 2,
  ORGANIZATION_TRIAL_STATUS_ACTIVE = 3,
  ORGANIZATION_TRIAL_STATUS_NOT_APPLICABLE = 4,
  ORGANIZATION_TRIAL_STATUS_FAILED = 5,
  ORGANIZATION_TRIAL_STATUS_TRIAL_INELIGIBLE = 6,
}

export function organizationTrialStatusFromJSON(object: any): OrganizationTrialStatus {
  switch (object) {
    case 0:
    case "ORGANIZATION_TRIAL_STATUS_UNSPECIFIED":
      return OrganizationTrialStatus.ORGANIZATION_TRIAL_STATUS_UNSPECIFIED;
    case 1:
    case "ORGANIZATION_TRIAL_STATUS_REQUIRED":
      return OrganizationTrialStatus.ORGANIZATION_TRIAL_STATUS_REQUIRED;
    case 2:
    case "ORGANIZATION_TRIAL_STATUS_CHECKOUT_PENDING":
      return OrganizationTrialStatus.ORGANIZATION_TRIAL_STATUS_CHECKOUT_PENDING;
    case 3:
    case "ORGANIZATION_TRIAL_STATUS_ACTIVE":
      return OrganizationTrialStatus.ORGANIZATION_TRIAL_STATUS_ACTIVE;
    case 4:
    case "ORGANIZATION_TRIAL_STATUS_NOT_APPLICABLE":
      return OrganizationTrialStatus.ORGANIZATION_TRIAL_STATUS_NOT_APPLICABLE;
    case 5:
    case "ORGANIZATION_TRIAL_STATUS_FAILED":
      return OrganizationTrialStatus.ORGANIZATION_TRIAL_STATUS_FAILED;
    case 6:
    case "ORGANIZATION_TRIAL_STATUS_TRIAL_INELIGIBLE":
      return OrganizationTrialStatus.ORGANIZATION_TRIAL_STATUS_TRIAL_INELIGIBLE;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum OrganizationTrialStatus");
  }
}

export function organizationTrialStatusToJSON(object: OrganizationTrialStatus): string {
  switch (object) {
    case OrganizationTrialStatus.ORGANIZATION_TRIAL_STATUS_UNSPECIFIED:
      return "ORGANIZATION_TRIAL_STATUS_UNSPECIFIED";
    case OrganizationTrialStatus.ORGANIZATION_TRIAL_STATUS_REQUIRED:
      return "ORGANIZATION_TRIAL_STATUS_REQUIRED";
    case OrganizationTrialStatus.ORGANIZATION_TRIAL_STATUS_CHECKOUT_PENDING:
      return "ORGANIZATION_TRIAL_STATUS_CHECKOUT_PENDING";
    case OrganizationTrialStatus.ORGANIZATION_TRIAL_STATUS_ACTIVE:
      return "ORGANIZATION_TRIAL_STATUS_ACTIVE";
    case OrganizationTrialStatus.ORGANIZATION_TRIAL_STATUS_NOT_APPLICABLE:
      return "ORGANIZATION_TRIAL_STATUS_NOT_APPLICABLE";
    case OrganizationTrialStatus.ORGANIZATION_TRIAL_STATUS_FAILED:
      return "ORGANIZATION_TRIAL_STATUS_FAILED";
    case OrganizationTrialStatus.ORGANIZATION_TRIAL_STATUS_TRIAL_INELIGIBLE:
      return "ORGANIZATION_TRIAL_STATUS_TRIAL_INELIGIBLE";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum OrganizationTrialStatus");
  }
}

export enum OrganizationTrialStartMethod {
  ORGANIZATION_TRIAL_START_METHOD_UNSPECIFIED = 0,
  ORGANIZATION_TRIAL_START_METHOD_CARD = 1,
  ORGANIZATION_TRIAL_START_METHOD_CARDLESS_EMAIL = 2,
}

export function organizationTrialStartMethodFromJSON(object: any): OrganizationTrialStartMethod {
  switch (object) {
    case 0:
    case "ORGANIZATION_TRIAL_START_METHOD_UNSPECIFIED":
      return OrganizationTrialStartMethod.ORGANIZATION_TRIAL_START_METHOD_UNSPECIFIED;
    case 1:
    case "ORGANIZATION_TRIAL_START_METHOD_CARD":
      return OrganizationTrialStartMethod.ORGANIZATION_TRIAL_START_METHOD_CARD;
    case 2:
    case "ORGANIZATION_TRIAL_START_METHOD_CARDLESS_EMAIL":
      return OrganizationTrialStartMethod.ORGANIZATION_TRIAL_START_METHOD_CARDLESS_EMAIL;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum OrganizationTrialStartMethod");
  }
}

export function organizationTrialStartMethodToJSON(object: OrganizationTrialStartMethod): string {
  switch (object) {
    case OrganizationTrialStartMethod.ORGANIZATION_TRIAL_START_METHOD_UNSPECIFIED:
      return "ORGANIZATION_TRIAL_START_METHOD_UNSPECIFIED";
    case OrganizationTrialStartMethod.ORGANIZATION_TRIAL_START_METHOD_CARD:
      return "ORGANIZATION_TRIAL_START_METHOD_CARD";
    case OrganizationTrialStartMethod.ORGANIZATION_TRIAL_START_METHOD_CARDLESS_EMAIL:
      return "ORGANIZATION_TRIAL_START_METHOD_CARDLESS_EMAIL";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum OrganizationTrialStartMethod");
  }
}

export interface CreateOrganizationRequest {
  org: EnterpriseOrganization | undefined;
}

export interface CreateOrganizationResponse {
  id: string;
}

export interface GetOrgCompaniesRequest {
  orgId: string;
}

export interface GetOrgCompaniesResponse {
  companyIds: number[];
}

export interface AddCompanyToOrgRequest {
  orgId: string;
  companyId: number;
}

export interface AddCompanyToOrgResponse {
}

export interface RemoveCompanyFromOrgRequest {
  orgId: string;
  companyId: number;
}

export interface RemoveCompanyFromOrgResponse {
}

export interface GetOrganizationUsersResponse {
  companyUsers: { [key: number]: CompanyUsersData };
  orgUsers: OrganizationUser[];
}

export interface GetOrganizationUsersResponse_CompanyUsersEntry {
  key: number;
  value: CompanyUsersData | undefined;
}

export interface CompanyUsersData {
  users: CompanyUser[];
}

/** Request to fetch organization usage analytics */
export interface GetOrgUsageRequest {
  start: Date | undefined;
  end: Date | undefined;
}

/** Response containing usage time-series data and metadata */
export interface GetOrgUsageResponse {
  timeSeries: UsageDataPoint[];
  summary: UsageSummary | undefined;
  granularity: string;
}

export interface UpdateOrganizationRequest {
  org: EnterpriseOrganization | undefined;
}

export interface UpdateOrganizationResponse {
  updated: EnterpriseOrganization | undefined;
}

export interface UpdateOrganizationMemberRequest {
  userId: string;
  role?: string | undefined;
}

export interface UpdateOrganizationMemberResponse {
}

export interface GetInvoicePreviewResponse {
  preview?: InvoicePreview | undefined;
}

export interface OrganizationCreditPlanOption {
  priceId: string;
  amountDollars: number;
  credits: number;
  currency: string;
}

export interface GetOrganizationCreditPlanResponse {
  state: OrganizationCreditPlanState | undefined;
  options: OrganizationCreditPlanOption[];
}

export interface StartOrganizationCreditPlanRequest {
  amountDollars: number;
  prorationDate: number;
}

export interface StartOrganizationCreditPlanResponse {
  sessionUrl?: string | undefined;
  state: OrganizationCreditPlanState | undefined;
}

export interface GetOrganizationTrialResponse {
  status: OrganizationTrialStatus;
  initialCredits?: number | undefined;
  trialEndsAt?: Date | undefined;
  errorMessage?: string | undefined;
  startMethod: OrganizationTrialStartMethod;
}

export interface StartOrganizationTrialRequest {
  companyId: number;
}

export interface StartOrganizationTrialResponse {
  sessionUrl?: string | undefined;
  trial?: GetOrganizationTrialResponse | undefined;
}

export interface PreviewOrganizationCreditPlanChangeRequest {
  amountDollars: number;
}

export interface PreviewOrganizationCreditPlanChangeResponse {
  immediateChargeCents: number;
  currency: string;
  prorationDate: number;
}

export interface GetOrganizationResponse {
  org: EnterpriseOrganization | undefined;
  orgCompanies: CompanyDetails[];
}

export interface OrganizationWorkspaceDataExport {
  workspace: CompanyDetails | undefined;
  projects: ProjectEntity[];
  documents: DocumentEntity[];
  attachments: AttachmentDetails[];
  catalog: OrganizationWorkspaceCatalogExport | undefined;
}

export interface OrganizationWorkspaceCatalogExport {
  productCatalog?: { [key: string]: any } | undefined;
  features: { [key: string]: any }[];
}

export interface OrganizationDataExport {
  formatVersion: number;
  exportedAt: Date | undefined;
  organization: EnterpriseOrganization | undefined;
  workspaces: OrganizationWorkspaceDataExport[];
}

function createBaseCreateOrganizationRequest(): CreateOrganizationRequest {
  return { org: undefined };
}

export const CreateOrganizationRequest: MessageFns<CreateOrganizationRequest> = {
  encode(message: CreateOrganizationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.org !== undefined) {
      EnterpriseOrganization.encode(message.org, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateOrganizationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateOrganizationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.org = EnterpriseOrganization.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateOrganizationRequest {
    return { org: isSet(object.org) ? EnterpriseOrganization.fromJSON(object.org) : undefined };
  },

  toJSON(message: CreateOrganizationRequest): unknown {
    const obj: any = {};
    if (message.org !== undefined) {
      obj.org = EnterpriseOrganization.toJSON(message.org);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateOrganizationRequest>): CreateOrganizationRequest {
    return CreateOrganizationRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateOrganizationRequest>): CreateOrganizationRequest {
    const message = createBaseCreateOrganizationRequest();
    message.org = (object.org !== undefined && object.org !== null)
      ? EnterpriseOrganization.fromPartial(object.org)
      : undefined;
    return message;
  },
};

function createBaseCreateOrganizationResponse(): CreateOrganizationResponse {
  return { id: "" };
}

export const CreateOrganizationResponse: MessageFns<CreateOrganizationResponse> = {
  encode(message: CreateOrganizationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateOrganizationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateOrganizationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateOrganizationResponse {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: CreateOrganizationResponse): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateOrganizationResponse>): CreateOrganizationResponse {
    return CreateOrganizationResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateOrganizationResponse>): CreateOrganizationResponse {
    const message = createBaseCreateOrganizationResponse();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseGetOrgCompaniesRequest(): GetOrgCompaniesRequest {
  return { orgId: "" };
}

export const GetOrgCompaniesRequest: MessageFns<GetOrgCompaniesRequest> = {
  encode(message: GetOrgCompaniesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOrgCompaniesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrgCompaniesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrgCompaniesRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
    };
  },

  toJSON(message: GetOrgCompaniesRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    return obj;
  },

  create(base?: DeepPartial<GetOrgCompaniesRequest>): GetOrgCompaniesRequest {
    return GetOrgCompaniesRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetOrgCompaniesRequest>): GetOrgCompaniesRequest {
    const message = createBaseGetOrgCompaniesRequest();
    message.orgId = object.orgId ?? "";
    return message;
  },
};

function createBaseGetOrgCompaniesResponse(): GetOrgCompaniesResponse {
  return { companyIds: [] };
}

export const GetOrgCompaniesResponse: MessageFns<GetOrgCompaniesResponse> = {
  encode(message: GetOrgCompaniesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.companyIds) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOrgCompaniesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrgCompaniesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.companyIds.push(reader.int32());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.companyIds.push(reader.int32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrgCompaniesResponse {
    return {
      companyIds: globalThis.Array.isArray(object?.companyIds)
        ? object.companyIds.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.company_ids)
        ? object.company_ids.map((e: any) => globalThis.Number(e))
        : [],
    };
  },

  toJSON(message: GetOrgCompaniesResponse): unknown {
    const obj: any = {};
    if (message.companyIds?.length) {
      obj.companyIds = message.companyIds.map((e) => Math.round(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetOrgCompaniesResponse>): GetOrgCompaniesResponse {
    return GetOrgCompaniesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetOrgCompaniesResponse>): GetOrgCompaniesResponse {
    const message = createBaseGetOrgCompaniesResponse();
    message.companyIds = object.companyIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseAddCompanyToOrgRequest(): AddCompanyToOrgRequest {
  return { orgId: "", companyId: 0 };
}

export const AddCompanyToOrgRequest: MessageFns<AddCompanyToOrgRequest> = {
  encode(message: AddCompanyToOrgRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddCompanyToOrgRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddCompanyToOrgRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddCompanyToOrgRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
    };
  },

  toJSON(message: AddCompanyToOrgRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    return obj;
  },

  create(base?: DeepPartial<AddCompanyToOrgRequest>): AddCompanyToOrgRequest {
    return AddCompanyToOrgRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AddCompanyToOrgRequest>): AddCompanyToOrgRequest {
    const message = createBaseAddCompanyToOrgRequest();
    message.orgId = object.orgId ?? "";
    message.companyId = object.companyId ?? 0;
    return message;
  },
};

function createBaseAddCompanyToOrgResponse(): AddCompanyToOrgResponse {
  return {};
}

export const AddCompanyToOrgResponse: MessageFns<AddCompanyToOrgResponse> = {
  encode(_: AddCompanyToOrgResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddCompanyToOrgResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddCompanyToOrgResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AddCompanyToOrgResponse {
    return {};
  },

  toJSON(_: AddCompanyToOrgResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<AddCompanyToOrgResponse>): AddCompanyToOrgResponse {
    return AddCompanyToOrgResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<AddCompanyToOrgResponse>): AddCompanyToOrgResponse {
    const message = createBaseAddCompanyToOrgResponse();
    return message;
  },
};

function createBaseRemoveCompanyFromOrgRequest(): RemoveCompanyFromOrgRequest {
  return { orgId: "", companyId: 0 };
}

export const RemoveCompanyFromOrgRequest: MessageFns<RemoveCompanyFromOrgRequest> = {
  encode(message: RemoveCompanyFromOrgRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveCompanyFromOrgRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveCompanyFromOrgRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveCompanyFromOrgRequest {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
    };
  },

  toJSON(message: RemoveCompanyFromOrgRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    return obj;
  },

  create(base?: DeepPartial<RemoveCompanyFromOrgRequest>): RemoveCompanyFromOrgRequest {
    return RemoveCompanyFromOrgRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RemoveCompanyFromOrgRequest>): RemoveCompanyFromOrgRequest {
    const message = createBaseRemoveCompanyFromOrgRequest();
    message.orgId = object.orgId ?? "";
    message.companyId = object.companyId ?? 0;
    return message;
  },
};

function createBaseRemoveCompanyFromOrgResponse(): RemoveCompanyFromOrgResponse {
  return {};
}

export const RemoveCompanyFromOrgResponse: MessageFns<RemoveCompanyFromOrgResponse> = {
  encode(_: RemoveCompanyFromOrgResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveCompanyFromOrgResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveCompanyFromOrgResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RemoveCompanyFromOrgResponse {
    return {};
  },

  toJSON(_: RemoveCompanyFromOrgResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<RemoveCompanyFromOrgResponse>): RemoveCompanyFromOrgResponse {
    return RemoveCompanyFromOrgResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<RemoveCompanyFromOrgResponse>): RemoveCompanyFromOrgResponse {
    const message = createBaseRemoveCompanyFromOrgResponse();
    return message;
  },
};

function createBaseGetOrganizationUsersResponse(): GetOrganizationUsersResponse {
  return { companyUsers: {}, orgUsers: [] };
}

export const GetOrganizationUsersResponse: MessageFns<GetOrganizationUsersResponse> = {
  encode(message: GetOrganizationUsersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.companyUsers).forEach(([key, value]: [string, CompanyUsersData]) => {
      GetOrganizationUsersResponse_CompanyUsersEntry.encode({ key: key as any, value }, writer.uint32(10).fork())
        .join();
    });
    for (const v of message.orgUsers) {
      OrganizationUser.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOrganizationUsersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrganizationUsersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = GetOrganizationUsersResponse_CompanyUsersEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.companyUsers[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgUsers.push(OrganizationUser.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrganizationUsersResponse {
    return {
      companyUsers: isObject(object.companyUsers)
        ? (globalThis.Object.entries(object.companyUsers) as [string, any][]).reduce(
          (acc: { [key: number]: CompanyUsersData }, [key, value]: [string, any]) => {
            acc[globalThis.Number(key)] = CompanyUsersData.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.company_users)
        ? (globalThis.Object.entries(object.company_users) as [string, any][]).reduce(
          (acc: { [key: number]: CompanyUsersData }, [key, value]: [string, any]) => {
            acc[globalThis.Number(key)] = CompanyUsersData.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      orgUsers: globalThis.Array.isArray(object?.orgUsers)
        ? object.orgUsers.map((e: any) => OrganizationUser.fromJSON(e))
        : globalThis.Array.isArray(object?.org_users)
        ? object.org_users.map((e: any) => OrganizationUser.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetOrganizationUsersResponse): unknown {
    const obj: any = {};
    if (message.companyUsers) {
      const entries = globalThis.Object.entries(message.companyUsers) as [string, CompanyUsersData][];
      if (entries.length > 0) {
        obj.companyUsers = {};
        entries.forEach(([k, v]) => {
          obj.companyUsers[k] = CompanyUsersData.toJSON(v);
        });
      }
    }
    if (message.orgUsers?.length) {
      obj.orgUsers = message.orgUsers.map((e) => OrganizationUser.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetOrganizationUsersResponse>): GetOrganizationUsersResponse {
    return GetOrganizationUsersResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetOrganizationUsersResponse>): GetOrganizationUsersResponse {
    const message = createBaseGetOrganizationUsersResponse();
    message.companyUsers = (globalThis.Object.entries(object.companyUsers ?? {}) as [string, CompanyUsersData][])
      .reduce((acc: { [key: number]: CompanyUsersData }, [key, value]: [string, CompanyUsersData]) => {
        if (value !== undefined) {
          acc[globalThis.Number(key)] = CompanyUsersData.fromPartial(value);
        }
        return acc;
      }, {});
    message.orgUsers = object.orgUsers?.map((e) => OrganizationUser.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetOrganizationUsersResponse_CompanyUsersEntry(): GetOrganizationUsersResponse_CompanyUsersEntry {
  return { key: 0, value: undefined };
}

export const GetOrganizationUsersResponse_CompanyUsersEntry: MessageFns<
  GetOrganizationUsersResponse_CompanyUsersEntry
> = {
  encode(
    message: GetOrganizationUsersResponse_CompanyUsersEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== 0) {
      writer.uint32(8).int32(message.key);
    }
    if (message.value !== undefined) {
      CompanyUsersData.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOrganizationUsersResponse_CompanyUsersEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrganizationUsersResponse_CompanyUsersEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.key = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = CompanyUsersData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrganizationUsersResponse_CompanyUsersEntry {
    return {
      key: isSet(object.key) ? globalThis.Number(object.key) : 0,
      value: isSet(object.value) ? CompanyUsersData.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: GetOrganizationUsersResponse_CompanyUsersEntry): unknown {
    const obj: any = {};
    if (message.key !== 0) {
      obj.key = Math.round(message.key);
    }
    if (message.value !== undefined) {
      obj.value = CompanyUsersData.toJSON(message.value);
    }
    return obj;
  },

  create(
    base?: DeepPartial<GetOrganizationUsersResponse_CompanyUsersEntry>,
  ): GetOrganizationUsersResponse_CompanyUsersEntry {
    return GetOrganizationUsersResponse_CompanyUsersEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<GetOrganizationUsersResponse_CompanyUsersEntry>,
  ): GetOrganizationUsersResponse_CompanyUsersEntry {
    const message = createBaseGetOrganizationUsersResponse_CompanyUsersEntry();
    message.key = object.key ?? 0;
    message.value = (object.value !== undefined && object.value !== null)
      ? CompanyUsersData.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseCompanyUsersData(): CompanyUsersData {
  return { users: [] };
}

export const CompanyUsersData: MessageFns<CompanyUsersData> = {
  encode(message: CompanyUsersData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.users) {
      CompanyUser.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompanyUsersData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompanyUsersData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.users.push(CompanyUser.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompanyUsersData {
    return {
      users: globalThis.Array.isArray(object?.users) ? object.users.map((e: any) => CompanyUser.fromJSON(e)) : [],
    };
  },

  toJSON(message: CompanyUsersData): unknown {
    const obj: any = {};
    if (message.users?.length) {
      obj.users = message.users.map((e) => CompanyUser.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<CompanyUsersData>): CompanyUsersData {
    return CompanyUsersData.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CompanyUsersData>): CompanyUsersData {
    const message = createBaseCompanyUsersData();
    message.users = object.users?.map((e) => CompanyUser.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetOrgUsageRequest(): GetOrgUsageRequest {
  return { start: undefined, end: undefined };
}

export const GetOrgUsageRequest: MessageFns<GetOrgUsageRequest> = {
  encode(message: GetOrgUsageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.start !== undefined) {
      Timestamp.encode(toTimestamp(message.start), writer.uint32(10).fork()).join();
    }
    if (message.end !== undefined) {
      Timestamp.encode(toTimestamp(message.end), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOrgUsageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrgUsageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.start = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.end = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrgUsageRequest {
    return {
      start: isSet(object.start) ? fromJsonTimestamp(object.start) : undefined,
      end: isSet(object.end) ? fromJsonTimestamp(object.end) : undefined,
    };
  },

  toJSON(message: GetOrgUsageRequest): unknown {
    const obj: any = {};
    if (message.start !== undefined) {
      obj.start = message.start.toISOString();
    }
    if (message.end !== undefined) {
      obj.end = message.end.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<GetOrgUsageRequest>): GetOrgUsageRequest {
    return GetOrgUsageRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetOrgUsageRequest>): GetOrgUsageRequest {
    const message = createBaseGetOrgUsageRequest();
    message.start = object.start ?? undefined;
    message.end = object.end ?? undefined;
    return message;
  },
};

function createBaseGetOrgUsageResponse(): GetOrgUsageResponse {
  return { timeSeries: [], summary: undefined, granularity: "" };
}

export const GetOrgUsageResponse: MessageFns<GetOrgUsageResponse> = {
  encode(message: GetOrgUsageResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.timeSeries) {
      UsageDataPoint.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.summary !== undefined) {
      UsageSummary.encode(message.summary, writer.uint32(18).fork()).join();
    }
    if (message.granularity !== "") {
      writer.uint32(26).string(message.granularity);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOrgUsageResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrgUsageResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.timeSeries.push(UsageDataPoint.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.summary = UsageSummary.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.granularity = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrgUsageResponse {
    return {
      timeSeries: globalThis.Array.isArray(object?.timeSeries)
        ? object.timeSeries.map((e: any) => UsageDataPoint.fromJSON(e))
        : globalThis.Array.isArray(object?.time_series)
        ? object.time_series.map((e: any) => UsageDataPoint.fromJSON(e))
        : [],
      summary: isSet(object.summary) ? UsageSummary.fromJSON(object.summary) : undefined,
      granularity: isSet(object.granularity) ? globalThis.String(object.granularity) : "",
    };
  },

  toJSON(message: GetOrgUsageResponse): unknown {
    const obj: any = {};
    if (message.timeSeries?.length) {
      obj.timeSeries = message.timeSeries.map((e) => UsageDataPoint.toJSON(e));
    }
    if (message.summary !== undefined) {
      obj.summary = UsageSummary.toJSON(message.summary);
    }
    if (message.granularity !== "") {
      obj.granularity = message.granularity;
    }
    return obj;
  },

  create(base?: DeepPartial<GetOrgUsageResponse>): GetOrgUsageResponse {
    return GetOrgUsageResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetOrgUsageResponse>): GetOrgUsageResponse {
    const message = createBaseGetOrgUsageResponse();
    message.timeSeries = object.timeSeries?.map((e) => UsageDataPoint.fromPartial(e)) || [];
    message.summary = (object.summary !== undefined && object.summary !== null)
      ? UsageSummary.fromPartial(object.summary)
      : undefined;
    message.granularity = object.granularity ?? "";
    return message;
  },
};

function createBaseUpdateOrganizationRequest(): UpdateOrganizationRequest {
  return { org: undefined };
}

export const UpdateOrganizationRequest: MessageFns<UpdateOrganizationRequest> = {
  encode(message: UpdateOrganizationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.org !== undefined) {
      EnterpriseOrganization.encode(message.org, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateOrganizationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateOrganizationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.org = EnterpriseOrganization.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateOrganizationRequest {
    return { org: isSet(object.org) ? EnterpriseOrganization.fromJSON(object.org) : undefined };
  },

  toJSON(message: UpdateOrganizationRequest): unknown {
    const obj: any = {};
    if (message.org !== undefined) {
      obj.org = EnterpriseOrganization.toJSON(message.org);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateOrganizationRequest>): UpdateOrganizationRequest {
    return UpdateOrganizationRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateOrganizationRequest>): UpdateOrganizationRequest {
    const message = createBaseUpdateOrganizationRequest();
    message.org = (object.org !== undefined && object.org !== null)
      ? EnterpriseOrganization.fromPartial(object.org)
      : undefined;
    return message;
  },
};

function createBaseUpdateOrganizationResponse(): UpdateOrganizationResponse {
  return { updated: undefined };
}

export const UpdateOrganizationResponse: MessageFns<UpdateOrganizationResponse> = {
  encode(message: UpdateOrganizationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.updated !== undefined) {
      EnterpriseOrganization.encode(message.updated, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateOrganizationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateOrganizationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.updated = EnterpriseOrganization.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateOrganizationResponse {
    return { updated: isSet(object.updated) ? EnterpriseOrganization.fromJSON(object.updated) : undefined };
  },

  toJSON(message: UpdateOrganizationResponse): unknown {
    const obj: any = {};
    if (message.updated !== undefined) {
      obj.updated = EnterpriseOrganization.toJSON(message.updated);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateOrganizationResponse>): UpdateOrganizationResponse {
    return UpdateOrganizationResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateOrganizationResponse>): UpdateOrganizationResponse {
    const message = createBaseUpdateOrganizationResponse();
    message.updated = (object.updated !== undefined && object.updated !== null)
      ? EnterpriseOrganization.fromPartial(object.updated)
      : undefined;
    return message;
  },
};

function createBaseUpdateOrganizationMemberRequest(): UpdateOrganizationMemberRequest {
  return { userId: "", role: undefined };
}

export const UpdateOrganizationMemberRequest: MessageFns<UpdateOrganizationMemberRequest> = {
  encode(message: UpdateOrganizationMemberRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.role !== undefined) {
      writer.uint32(18).string(message.role);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateOrganizationMemberRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateOrganizationMemberRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.role = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateOrganizationMemberRequest {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      role: isSet(object.role) ? globalThis.String(object.role) : undefined,
    };
  },

  toJSON(message: UpdateOrganizationMemberRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.role !== undefined) {
      obj.role = message.role;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateOrganizationMemberRequest>): UpdateOrganizationMemberRequest {
    return UpdateOrganizationMemberRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateOrganizationMemberRequest>): UpdateOrganizationMemberRequest {
    const message = createBaseUpdateOrganizationMemberRequest();
    message.userId = object.userId ?? "";
    message.role = object.role ?? undefined;
    return message;
  },
};

function createBaseUpdateOrganizationMemberResponse(): UpdateOrganizationMemberResponse {
  return {};
}

export const UpdateOrganizationMemberResponse: MessageFns<UpdateOrganizationMemberResponse> = {
  encode(_: UpdateOrganizationMemberResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateOrganizationMemberResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateOrganizationMemberResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UpdateOrganizationMemberResponse {
    return {};
  },

  toJSON(_: UpdateOrganizationMemberResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<UpdateOrganizationMemberResponse>): UpdateOrganizationMemberResponse {
    return UpdateOrganizationMemberResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<UpdateOrganizationMemberResponse>): UpdateOrganizationMemberResponse {
    const message = createBaseUpdateOrganizationMemberResponse();
    return message;
  },
};

function createBaseGetInvoicePreviewResponse(): GetInvoicePreviewResponse {
  return { preview: undefined };
}

export const GetInvoicePreviewResponse: MessageFns<GetInvoicePreviewResponse> = {
  encode(message: GetInvoicePreviewResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.preview !== undefined) {
      InvoicePreview.encode(message.preview, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetInvoicePreviewResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetInvoicePreviewResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.preview = InvoicePreview.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetInvoicePreviewResponse {
    return { preview: isSet(object.preview) ? InvoicePreview.fromJSON(object.preview) : undefined };
  },

  toJSON(message: GetInvoicePreviewResponse): unknown {
    const obj: any = {};
    if (message.preview !== undefined) {
      obj.preview = InvoicePreview.toJSON(message.preview);
    }
    return obj;
  },

  create(base?: DeepPartial<GetInvoicePreviewResponse>): GetInvoicePreviewResponse {
    return GetInvoicePreviewResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetInvoicePreviewResponse>): GetInvoicePreviewResponse {
    const message = createBaseGetInvoicePreviewResponse();
    message.preview = (object.preview !== undefined && object.preview !== null)
      ? InvoicePreview.fromPartial(object.preview)
      : undefined;
    return message;
  },
};

function createBaseOrganizationCreditPlanOption(): OrganizationCreditPlanOption {
  return { priceId: "", amountDollars: 0, credits: 0, currency: "" };
}

export const OrganizationCreditPlanOption: MessageFns<OrganizationCreditPlanOption> = {
  encode(message: OrganizationCreditPlanOption, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.priceId !== "") {
      writer.uint32(10).string(message.priceId);
    }
    if (message.amountDollars !== 0) {
      writer.uint32(16).int32(message.amountDollars);
    }
    if (message.credits !== 0) {
      writer.uint32(24).int32(message.credits);
    }
    if (message.currency !== "") {
      writer.uint32(34).string(message.currency);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrganizationCreditPlanOption {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganizationCreditPlanOption();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.priceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.amountDollars = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.credits = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.currency = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrganizationCreditPlanOption {
    return {
      priceId: isSet(object.priceId)
        ? globalThis.String(object.priceId)
        : isSet(object.price_id)
        ? globalThis.String(object.price_id)
        : "",
      amountDollars: isSet(object.amountDollars)
        ? globalThis.Number(object.amountDollars)
        : isSet(object.amount_dollars)
        ? globalThis.Number(object.amount_dollars)
        : 0,
      credits: isSet(object.credits) ? globalThis.Number(object.credits) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
    };
  },

  toJSON(message: OrganizationCreditPlanOption): unknown {
    const obj: any = {};
    if (message.priceId !== "") {
      obj.priceId = message.priceId;
    }
    if (message.amountDollars !== 0) {
      obj.amountDollars = Math.round(message.amountDollars);
    }
    if (message.credits !== 0) {
      obj.credits = Math.round(message.credits);
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    return obj;
  },

  create(base?: DeepPartial<OrganizationCreditPlanOption>): OrganizationCreditPlanOption {
    return OrganizationCreditPlanOption.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<OrganizationCreditPlanOption>): OrganizationCreditPlanOption {
    const message = createBaseOrganizationCreditPlanOption();
    message.priceId = object.priceId ?? "";
    message.amountDollars = object.amountDollars ?? 0;
    message.credits = object.credits ?? 0;
    message.currency = object.currency ?? "";
    return message;
  },
};

function createBaseGetOrganizationCreditPlanResponse(): GetOrganizationCreditPlanResponse {
  return { state: undefined, options: [] };
}

export const GetOrganizationCreditPlanResponse: MessageFns<GetOrganizationCreditPlanResponse> = {
  encode(message: GetOrganizationCreditPlanResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.state !== undefined) {
      OrganizationCreditPlanState.encode(message.state, writer.uint32(10).fork()).join();
    }
    for (const v of message.options) {
      OrganizationCreditPlanOption.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOrganizationCreditPlanResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrganizationCreditPlanResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.state = OrganizationCreditPlanState.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.options.push(OrganizationCreditPlanOption.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrganizationCreditPlanResponse {
    return {
      state: isSet(object.state) ? OrganizationCreditPlanState.fromJSON(object.state) : undefined,
      options: globalThis.Array.isArray(object?.options)
        ? object.options.map((e: any) => OrganizationCreditPlanOption.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetOrganizationCreditPlanResponse): unknown {
    const obj: any = {};
    if (message.state !== undefined) {
      obj.state = OrganizationCreditPlanState.toJSON(message.state);
    }
    if (message.options?.length) {
      obj.options = message.options.map((e) => OrganizationCreditPlanOption.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetOrganizationCreditPlanResponse>): GetOrganizationCreditPlanResponse {
    return GetOrganizationCreditPlanResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetOrganizationCreditPlanResponse>): GetOrganizationCreditPlanResponse {
    const message = createBaseGetOrganizationCreditPlanResponse();
    message.state = (object.state !== undefined && object.state !== null)
      ? OrganizationCreditPlanState.fromPartial(object.state)
      : undefined;
    message.options = object.options?.map((e) => OrganizationCreditPlanOption.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStartOrganizationCreditPlanRequest(): StartOrganizationCreditPlanRequest {
  return { amountDollars: 0, prorationDate: 0 };
}

export const StartOrganizationCreditPlanRequest: MessageFns<StartOrganizationCreditPlanRequest> = {
  encode(message: StartOrganizationCreditPlanRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.amountDollars !== 0) {
      writer.uint32(8).int32(message.amountDollars);
    }
    if (message.prorationDate !== 0) {
      writer.uint32(16).int64(message.prorationDate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartOrganizationCreditPlanRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartOrganizationCreditPlanRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.amountDollars = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.prorationDate = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartOrganizationCreditPlanRequest {
    return {
      amountDollars: isSet(object.amountDollars)
        ? globalThis.Number(object.amountDollars)
        : isSet(object.amount_dollars)
        ? globalThis.Number(object.amount_dollars)
        : 0,
      prorationDate: isSet(object.prorationDate)
        ? globalThis.Number(object.prorationDate)
        : isSet(object.proration_date)
        ? globalThis.Number(object.proration_date)
        : 0,
    };
  },

  toJSON(message: StartOrganizationCreditPlanRequest): unknown {
    const obj: any = {};
    if (message.amountDollars !== 0) {
      obj.amountDollars = Math.round(message.amountDollars);
    }
    if (message.prorationDate !== 0) {
      obj.prorationDate = Math.round(message.prorationDate);
    }
    return obj;
  },

  create(base?: DeepPartial<StartOrganizationCreditPlanRequest>): StartOrganizationCreditPlanRequest {
    return StartOrganizationCreditPlanRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartOrganizationCreditPlanRequest>): StartOrganizationCreditPlanRequest {
    const message = createBaseStartOrganizationCreditPlanRequest();
    message.amountDollars = object.amountDollars ?? 0;
    message.prorationDate = object.prorationDate ?? 0;
    return message;
  },
};

function createBaseStartOrganizationCreditPlanResponse(): StartOrganizationCreditPlanResponse {
  return { sessionUrl: undefined, state: undefined };
}

export const StartOrganizationCreditPlanResponse: MessageFns<StartOrganizationCreditPlanResponse> = {
  encode(message: StartOrganizationCreditPlanResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sessionUrl !== undefined) {
      writer.uint32(10).string(message.sessionUrl);
    }
    if (message.state !== undefined) {
      OrganizationCreditPlanState.encode(message.state, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartOrganizationCreditPlanResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartOrganizationCreditPlanResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sessionUrl = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.state = OrganizationCreditPlanState.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartOrganizationCreditPlanResponse {
    return {
      sessionUrl: isSet(object.sessionUrl)
        ? globalThis.String(object.sessionUrl)
        : isSet(object.session_url)
        ? globalThis.String(object.session_url)
        : undefined,
      state: isSet(object.state) ? OrganizationCreditPlanState.fromJSON(object.state) : undefined,
    };
  },

  toJSON(message: StartOrganizationCreditPlanResponse): unknown {
    const obj: any = {};
    if (message.sessionUrl !== undefined) {
      obj.sessionUrl = message.sessionUrl;
    }
    if (message.state !== undefined) {
      obj.state = OrganizationCreditPlanState.toJSON(message.state);
    }
    return obj;
  },

  create(base?: DeepPartial<StartOrganizationCreditPlanResponse>): StartOrganizationCreditPlanResponse {
    return StartOrganizationCreditPlanResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartOrganizationCreditPlanResponse>): StartOrganizationCreditPlanResponse {
    const message = createBaseStartOrganizationCreditPlanResponse();
    message.sessionUrl = object.sessionUrl ?? undefined;
    message.state = (object.state !== undefined && object.state !== null)
      ? OrganizationCreditPlanState.fromPartial(object.state)
      : undefined;
    return message;
  },
};

function createBaseGetOrganizationTrialResponse(): GetOrganizationTrialResponse {
  return { status: 0, initialCredits: undefined, trialEndsAt: undefined, errorMessage: undefined, startMethod: 0 };
}

export const GetOrganizationTrialResponse: MessageFns<GetOrganizationTrialResponse> = {
  encode(message: GetOrganizationTrialResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.initialCredits !== undefined) {
      writer.uint32(16).int32(message.initialCredits);
    }
    if (message.trialEndsAt !== undefined) {
      Timestamp.encode(toTimestamp(message.trialEndsAt), writer.uint32(26).fork()).join();
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(34).string(message.errorMessage);
    }
    if (message.startMethod !== 0) {
      writer.uint32(40).int32(message.startMethod);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOrganizationTrialResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrganizationTrialResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.initialCredits = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.trialEndsAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.startMethod = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrganizationTrialResponse {
    return {
      status: isSet(object.status) ? organizationTrialStatusFromJSON(object.status) : 0,
      initialCredits: isSet(object.initialCredits)
        ? globalThis.Number(object.initialCredits)
        : isSet(object.initial_credits)
        ? globalThis.Number(object.initial_credits)
        : undefined,
      trialEndsAt: isSet(object.trialEndsAt)
        ? fromJsonTimestamp(object.trialEndsAt)
        : isSet(object.trial_ends_at)
        ? fromJsonTimestamp(object.trial_ends_at)
        : undefined,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
        ? globalThis.String(object.error_message)
        : undefined,
      startMethod: isSet(object.startMethod)
        ? organizationTrialStartMethodFromJSON(object.startMethod)
        : isSet(object.start_method)
        ? organizationTrialStartMethodFromJSON(object.start_method)
        : 0,
    };
  },

  toJSON(message: GetOrganizationTrialResponse): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = organizationTrialStatusToJSON(message.status);
    }
    if (message.initialCredits !== undefined) {
      obj.initialCredits = Math.round(message.initialCredits);
    }
    if (message.trialEndsAt !== undefined) {
      obj.trialEndsAt = message.trialEndsAt.toISOString();
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage;
    }
    if (message.startMethod !== 0) {
      obj.startMethod = organizationTrialStartMethodToJSON(message.startMethod);
    }
    return obj;
  },

  create(base?: DeepPartial<GetOrganizationTrialResponse>): GetOrganizationTrialResponse {
    return GetOrganizationTrialResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetOrganizationTrialResponse>): GetOrganizationTrialResponse {
    const message = createBaseGetOrganizationTrialResponse();
    message.status = object.status ?? 0;
    message.initialCredits = object.initialCredits ?? undefined;
    message.trialEndsAt = object.trialEndsAt ?? undefined;
    message.errorMessage = object.errorMessage ?? undefined;
    message.startMethod = object.startMethod ?? 0;
    return message;
  },
};

function createBaseStartOrganizationTrialRequest(): StartOrganizationTrialRequest {
  return { companyId: 0 };
}

export const StartOrganizationTrialRequest: MessageFns<StartOrganizationTrialRequest> = {
  encode(message: StartOrganizationTrialRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartOrganizationTrialRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartOrganizationTrialRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartOrganizationTrialRequest {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
    };
  },

  toJSON(message: StartOrganizationTrialRequest): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    return obj;
  },

  create(base?: DeepPartial<StartOrganizationTrialRequest>): StartOrganizationTrialRequest {
    return StartOrganizationTrialRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartOrganizationTrialRequest>): StartOrganizationTrialRequest {
    const message = createBaseStartOrganizationTrialRequest();
    message.companyId = object.companyId ?? 0;
    return message;
  },
};

function createBaseStartOrganizationTrialResponse(): StartOrganizationTrialResponse {
  return { sessionUrl: undefined, trial: undefined };
}

export const StartOrganizationTrialResponse: MessageFns<StartOrganizationTrialResponse> = {
  encode(message: StartOrganizationTrialResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sessionUrl !== undefined) {
      writer.uint32(10).string(message.sessionUrl);
    }
    if (message.trial !== undefined) {
      GetOrganizationTrialResponse.encode(message.trial, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartOrganizationTrialResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartOrganizationTrialResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sessionUrl = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.trial = GetOrganizationTrialResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartOrganizationTrialResponse {
    return {
      sessionUrl: isSet(object.sessionUrl)
        ? globalThis.String(object.sessionUrl)
        : isSet(object.session_url)
        ? globalThis.String(object.session_url)
        : undefined,
      trial: isSet(object.trial) ? GetOrganizationTrialResponse.fromJSON(object.trial) : undefined,
    };
  },

  toJSON(message: StartOrganizationTrialResponse): unknown {
    const obj: any = {};
    if (message.sessionUrl !== undefined) {
      obj.sessionUrl = message.sessionUrl;
    }
    if (message.trial !== undefined) {
      obj.trial = GetOrganizationTrialResponse.toJSON(message.trial);
    }
    return obj;
  },

  create(base?: DeepPartial<StartOrganizationTrialResponse>): StartOrganizationTrialResponse {
    return StartOrganizationTrialResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartOrganizationTrialResponse>): StartOrganizationTrialResponse {
    const message = createBaseStartOrganizationTrialResponse();
    message.sessionUrl = object.sessionUrl ?? undefined;
    message.trial = (object.trial !== undefined && object.trial !== null)
      ? GetOrganizationTrialResponse.fromPartial(object.trial)
      : undefined;
    return message;
  },
};

function createBasePreviewOrganizationCreditPlanChangeRequest(): PreviewOrganizationCreditPlanChangeRequest {
  return { amountDollars: 0 };
}

export const PreviewOrganizationCreditPlanChangeRequest: MessageFns<PreviewOrganizationCreditPlanChangeRequest> = {
  encode(message: PreviewOrganizationCreditPlanChangeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.amountDollars !== 0) {
      writer.uint32(8).int32(message.amountDollars);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PreviewOrganizationCreditPlanChangeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePreviewOrganizationCreditPlanChangeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.amountDollars = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PreviewOrganizationCreditPlanChangeRequest {
    return {
      amountDollars: isSet(object.amountDollars)
        ? globalThis.Number(object.amountDollars)
        : isSet(object.amount_dollars)
        ? globalThis.Number(object.amount_dollars)
        : 0,
    };
  },

  toJSON(message: PreviewOrganizationCreditPlanChangeRequest): unknown {
    const obj: any = {};
    if (message.amountDollars !== 0) {
      obj.amountDollars = Math.round(message.amountDollars);
    }
    return obj;
  },

  create(base?: DeepPartial<PreviewOrganizationCreditPlanChangeRequest>): PreviewOrganizationCreditPlanChangeRequest {
    return PreviewOrganizationCreditPlanChangeRequest.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<PreviewOrganizationCreditPlanChangeRequest>,
  ): PreviewOrganizationCreditPlanChangeRequest {
    const message = createBasePreviewOrganizationCreditPlanChangeRequest();
    message.amountDollars = object.amountDollars ?? 0;
    return message;
  },
};

function createBasePreviewOrganizationCreditPlanChangeResponse(): PreviewOrganizationCreditPlanChangeResponse {
  return { immediateChargeCents: 0, currency: "", prorationDate: 0 };
}

export const PreviewOrganizationCreditPlanChangeResponse: MessageFns<PreviewOrganizationCreditPlanChangeResponse> = {
  encode(
    message: PreviewOrganizationCreditPlanChangeResponse,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.immediateChargeCents !== 0) {
      writer.uint32(8).int64(message.immediateChargeCents);
    }
    if (message.currency !== "") {
      writer.uint32(18).string(message.currency);
    }
    if (message.prorationDate !== 0) {
      writer.uint32(24).int64(message.prorationDate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PreviewOrganizationCreditPlanChangeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePreviewOrganizationCreditPlanChangeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.immediateChargeCents = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.currency = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.prorationDate = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PreviewOrganizationCreditPlanChangeResponse {
    return {
      immediateChargeCents: isSet(object.immediateChargeCents)
        ? globalThis.Number(object.immediateChargeCents)
        : isSet(object.immediate_charge_cents)
        ? globalThis.Number(object.immediate_charge_cents)
        : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      prorationDate: isSet(object.prorationDate)
        ? globalThis.Number(object.prorationDate)
        : isSet(object.proration_date)
        ? globalThis.Number(object.proration_date)
        : 0,
    };
  },

  toJSON(message: PreviewOrganizationCreditPlanChangeResponse): unknown {
    const obj: any = {};
    if (message.immediateChargeCents !== 0) {
      obj.immediateChargeCents = Math.round(message.immediateChargeCents);
    }
    if (message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.prorationDate !== 0) {
      obj.prorationDate = Math.round(message.prorationDate);
    }
    return obj;
  },

  create(base?: DeepPartial<PreviewOrganizationCreditPlanChangeResponse>): PreviewOrganizationCreditPlanChangeResponse {
    return PreviewOrganizationCreditPlanChangeResponse.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<PreviewOrganizationCreditPlanChangeResponse>,
  ): PreviewOrganizationCreditPlanChangeResponse {
    const message = createBasePreviewOrganizationCreditPlanChangeResponse();
    message.immediateChargeCents = object.immediateChargeCents ?? 0;
    message.currency = object.currency ?? "";
    message.prorationDate = object.prorationDate ?? 0;
    return message;
  },
};

function createBaseGetOrganizationResponse(): GetOrganizationResponse {
  return { org: undefined, orgCompanies: [] };
}

export const GetOrganizationResponse: MessageFns<GetOrganizationResponse> = {
  encode(message: GetOrganizationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.org !== undefined) {
      EnterpriseOrganization.encode(message.org, writer.uint32(10).fork()).join();
    }
    for (const v of message.orgCompanies) {
      CompanyDetails.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOrganizationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrganizationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.org = EnterpriseOrganization.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgCompanies.push(CompanyDetails.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrganizationResponse {
    return {
      org: isSet(object.org) ? EnterpriseOrganization.fromJSON(object.org) : undefined,
      orgCompanies: globalThis.Array.isArray(object?.orgCompanies)
        ? object.orgCompanies.map((e: any) => CompanyDetails.fromJSON(e))
        : globalThis.Array.isArray(object?.org_companies)
        ? object.org_companies.map((e: any) => CompanyDetails.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetOrganizationResponse): unknown {
    const obj: any = {};
    if (message.org !== undefined) {
      obj.org = EnterpriseOrganization.toJSON(message.org);
    }
    if (message.orgCompanies?.length) {
      obj.orgCompanies = message.orgCompanies.map((e) => CompanyDetails.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetOrganizationResponse>): GetOrganizationResponse {
    return GetOrganizationResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetOrganizationResponse>): GetOrganizationResponse {
    const message = createBaseGetOrganizationResponse();
    message.org = (object.org !== undefined && object.org !== null)
      ? EnterpriseOrganization.fromPartial(object.org)
      : undefined;
    message.orgCompanies = object.orgCompanies?.map((e) => CompanyDetails.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOrganizationWorkspaceDataExport(): OrganizationWorkspaceDataExport {
  return { workspace: undefined, projects: [], documents: [], attachments: [], catalog: undefined };
}

export const OrganizationWorkspaceDataExport: MessageFns<OrganizationWorkspaceDataExport> = {
  encode(message: OrganizationWorkspaceDataExport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.workspace !== undefined) {
      CompanyDetails.encode(message.workspace, writer.uint32(10).fork()).join();
    }
    for (const v of message.projects) {
      ProjectEntity.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.documents) {
      DocumentEntity.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.attachments) {
      AttachmentDetails.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.catalog !== undefined) {
      OrganizationWorkspaceCatalogExport.encode(message.catalog, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrganizationWorkspaceDataExport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganizationWorkspaceDataExport();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.workspace = CompanyDetails.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.projects.push(ProjectEntity.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.documents.push(DocumentEntity.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.attachments.push(AttachmentDetails.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.catalog = OrganizationWorkspaceCatalogExport.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrganizationWorkspaceDataExport {
    return {
      workspace: isSet(object.workspace) ? CompanyDetails.fromJSON(object.workspace) : undefined,
      projects: globalThis.Array.isArray(object?.projects)
        ? object.projects.map((e: any) => ProjectEntity.fromJSON(e))
        : [],
      documents: globalThis.Array.isArray(object?.documents)
        ? object.documents.map((e: any) => DocumentEntity.fromJSON(e))
        : [],
      attachments: globalThis.Array.isArray(object?.attachments)
        ? object.attachments.map((e: any) => AttachmentDetails.fromJSON(e))
        : [],
      catalog: isSet(object.catalog) ? OrganizationWorkspaceCatalogExport.fromJSON(object.catalog) : undefined,
    };
  },

  toJSON(message: OrganizationWorkspaceDataExport): unknown {
    const obj: any = {};
    if (message.workspace !== undefined) {
      obj.workspace = CompanyDetails.toJSON(message.workspace);
    }
    if (message.projects?.length) {
      obj.projects = message.projects.map((e) => ProjectEntity.toJSON(e));
    }
    if (message.documents?.length) {
      obj.documents = message.documents.map((e) => DocumentEntity.toJSON(e));
    }
    if (message.attachments?.length) {
      obj.attachments = message.attachments.map((e) => AttachmentDetails.toJSON(e));
    }
    if (message.catalog !== undefined) {
      obj.catalog = OrganizationWorkspaceCatalogExport.toJSON(message.catalog);
    }
    return obj;
  },

  create(base?: DeepPartial<OrganizationWorkspaceDataExport>): OrganizationWorkspaceDataExport {
    return OrganizationWorkspaceDataExport.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<OrganizationWorkspaceDataExport>): OrganizationWorkspaceDataExport {
    const message = createBaseOrganizationWorkspaceDataExport();
    message.workspace = (object.workspace !== undefined && object.workspace !== null)
      ? CompanyDetails.fromPartial(object.workspace)
      : undefined;
    message.projects = object.projects?.map((e) => ProjectEntity.fromPartial(e)) || [];
    message.documents = object.documents?.map((e) => DocumentEntity.fromPartial(e)) || [];
    message.attachments = object.attachments?.map((e) => AttachmentDetails.fromPartial(e)) || [];
    message.catalog = (object.catalog !== undefined && object.catalog !== null)
      ? OrganizationWorkspaceCatalogExport.fromPartial(object.catalog)
      : undefined;
    return message;
  },
};

function createBaseOrganizationWorkspaceCatalogExport(): OrganizationWorkspaceCatalogExport {
  return { productCatalog: undefined, features: [] };
}

export const OrganizationWorkspaceCatalogExport: MessageFns<OrganizationWorkspaceCatalogExport> = {
  encode(message: OrganizationWorkspaceCatalogExport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.productCatalog !== undefined) {
      Struct.encode(Struct.wrap(message.productCatalog), writer.uint32(10).fork()).join();
    }
    for (const v of message.features) {
      Struct.encode(Struct.wrap(v!), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrganizationWorkspaceCatalogExport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganizationWorkspaceCatalogExport();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.productCatalog = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.features.push(Struct.unwrap(Struct.decode(reader, reader.uint32())));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrganizationWorkspaceCatalogExport {
    return {
      productCatalog: isObject(object.productCatalog)
        ? object.productCatalog
        : isObject(object.product_catalog)
        ? object.product_catalog
        : undefined,
      features: globalThis.Array.isArray(object?.features) ? [...object.features] : [],
    };
  },

  toJSON(message: OrganizationWorkspaceCatalogExport): unknown {
    const obj: any = {};
    if (message.productCatalog !== undefined) {
      obj.productCatalog = message.productCatalog;
    }
    if (message.features?.length) {
      obj.features = message.features;
    }
    return obj;
  },

  create(base?: DeepPartial<OrganizationWorkspaceCatalogExport>): OrganizationWorkspaceCatalogExport {
    return OrganizationWorkspaceCatalogExport.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<OrganizationWorkspaceCatalogExport>): OrganizationWorkspaceCatalogExport {
    const message = createBaseOrganizationWorkspaceCatalogExport();
    message.productCatalog = object.productCatalog ?? undefined;
    message.features = object.features?.map((e) => e) || [];
    return message;
  },
};

function createBaseOrganizationDataExport(): OrganizationDataExport {
  return { formatVersion: 0, exportedAt: undefined, organization: undefined, workspaces: [] };
}

export const OrganizationDataExport: MessageFns<OrganizationDataExport> = {
  encode(message: OrganizationDataExport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.formatVersion !== 0) {
      writer.uint32(8).int32(message.formatVersion);
    }
    if (message.exportedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.exportedAt), writer.uint32(18).fork()).join();
    }
    if (message.organization !== undefined) {
      EnterpriseOrganization.encode(message.organization, writer.uint32(26).fork()).join();
    }
    for (const v of message.workspaces) {
      OrganizationWorkspaceDataExport.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrganizationDataExport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganizationDataExport();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.formatVersion = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.exportedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.organization = EnterpriseOrganization.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.workspaces.push(OrganizationWorkspaceDataExport.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrganizationDataExport {
    return {
      formatVersion: isSet(object.formatVersion)
        ? globalThis.Number(object.formatVersion)
        : isSet(object.format_version)
        ? globalThis.Number(object.format_version)
        : 0,
      exportedAt: isSet(object.exportedAt)
        ? fromJsonTimestamp(object.exportedAt)
        : isSet(object.exported_at)
        ? fromJsonTimestamp(object.exported_at)
        : undefined,
      organization: isSet(object.organization) ? EnterpriseOrganization.fromJSON(object.organization) : undefined,
      workspaces: globalThis.Array.isArray(object?.workspaces)
        ? object.workspaces.map((e: any) => OrganizationWorkspaceDataExport.fromJSON(e))
        : [],
    };
  },

  toJSON(message: OrganizationDataExport): unknown {
    const obj: any = {};
    if (message.formatVersion !== 0) {
      obj.formatVersion = Math.round(message.formatVersion);
    }
    if (message.exportedAt !== undefined) {
      obj.exportedAt = message.exportedAt.toISOString();
    }
    if (message.organization !== undefined) {
      obj.organization = EnterpriseOrganization.toJSON(message.organization);
    }
    if (message.workspaces?.length) {
      obj.workspaces = message.workspaces.map((e) => OrganizationWorkspaceDataExport.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<OrganizationDataExport>): OrganizationDataExport {
    return OrganizationDataExport.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<OrganizationDataExport>): OrganizationDataExport {
    const message = createBaseOrganizationDataExport();
    message.formatVersion = object.formatVersion ?? 0;
    message.exportedAt = object.exportedAt ?? undefined;
    message.organization = (object.organization !== undefined && object.organization !== null)
      ? EnterpriseOrganization.fromPartial(object.organization)
      : undefined;
    message.workspaces = object.workspaces?.map((e) => OrganizationWorkspaceDataExport.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
